import { ApiPermissions } from "../shared/services/volateq-api/api-permissions";
import { PermissionOperator, RouteOptions } from "../types";

const AppPlantView = () => import("@/app/plant/plant-view.vue");
const AppPlants = () => import("@/app/plant/plants.vue");
const AppPlantSettings = () => import("@/app/plant/shared/plant-settings/plant-settings.vue");

const plantRoutes: RouteOptions[] = [
  {
    name: "Plants",
    path: "/plants",
    component: AppPlants,
  },
  {
    name: "Plant",
    path: "/plant/:id",
    component: AppPlantView,
    meta: {
      permission: [
        ApiPermissions.READ_ANALYSIS_RESULT,
        ApiPermissions.READ_DIGITAL_TWIN_VISUALIZATION,
        ApiPermissions.READ_OBSERVATION,
        ApiPermissions.READ_ALL_PLANT,
      ],
      permOperator: PermissionOperator.OR,
    }
  },
  {
    name: "PlantSettings",
    path: "/plant/:id/settings",
    component: AppPlantSettings,
    meta: {
      permission: [ApiPermissions.MANAGE_CUSTOM_COMPONENT_PROPERTY, ApiPermissions.MANAGE_ENABLED_PI_FIELD],
    }
  },
];

export default plantRoutes;
